import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const getCategory = createAsyncThunk(
  "admin/getCategory",
  async (_, { rejectWithValue }) => {  
    try {
      const response = await api.get("/content/categoryList");
      return response.data.categoryList; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getContentList = createAsyncThunk(
  'notice/getContentList',
  async (endpoint , { rejectWithValue }) => {
    try {
      const response = await api.get(endpoint);
      return response.data; 
    } catch (error) {
      // console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAlarmContentList = createAsyncThunk(
  'notice/getAlarmContentList',
  async (endpoint , { rejectWithValue }) => {
    try {
      const response = await api.get(endpoint);
      return response.data; 
    } catch (error) {
      // console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getContent = createAsyncThunk(
  'notice/getContent',
  async ({ noticeId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/content/${noticeId}`); 
      return response.data; 
    } catch (error) {
      if (error.response) {
        const errorCode = error.response.status; 
        if (error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        }
        return rejectWithValue(errorCode);    
      }
      return rejectWithValue(error.message);
    }
  }
);


export const createContent = createAsyncThunk(
  'notice/createContent',
  async ({ data, endpoint }, { rejectWithValue }) => {
      try {
          const response = await api.post(endpoint, data);
          if (response.status !== 200) throw new Error('Failed to create content');
        return {
          message: response.data.message,
          contentId: response.data.contentId,
        };
      } catch (error) {
          // console.error(error);

          if(error.response && error.response.data && error.response.data.error){
            return rejectWithValue(error.response.data.error);    
          }

          return rejectWithValue(error.message);
      }
  }
);

export const updateContent = createAsyncThunk(
  'notice/updateContent',
  async ({ noticeId, data }, { rejectWithValue }) => {
      try {
        const response = await api.put(`/content/${noticeId}`, data);
        // console.log(response);  
        if (response.status !== 200) throw new Error('Failed to update content');
        return {
          message: response.data.message,
          contentId: response.data.contentId,
        };
        
      } catch (error) {
          // console.error('Failed to update content:', error);

          if (error.response && error.response.data && error.response.data.error) {
            return rejectWithValue(error.response.data.error);    
          }

          return rejectWithValue(error.message);
      }
  }
);
export const updateIMGContent = createAsyncThunk(
  'notice/updateIMGContent',
  async ({ noticeId, data }, { rejectWithValue }) => {
      try {
        const response = await api.put(`/content/img/${noticeId}`, data);
        // console.log(response);  
        if (response.status !== 200) throw new Error('Failed to update img in content');
        return response.data;
        
      } catch (error) {
          // console.error('Failed to update content:', error);

          if (error.response && error.response.data && error.response.data.error) {
            return rejectWithValue(error.response.data.error);    
          }

          return rejectWithValue(error.message);
      }
  }
);


export const deleteContent = createAsyncThunk(
  'notice/deleteContent',
  async ({ noticeId }, { rejectWithValue }) => {
    try {
     
      const response = await api.delete(`/content/${noticeId}`);

      return response.data;
    } catch (error) {
      // console.error('Error deleting content:', error);
      return rejectWithValue(error.message);
    }
  }
);


//에디터 내 이미지 업로드
export const uploadImg = createAsyncThunk(
  'notice/handleFileUpload',
  async ({ data, endpoint }, { rejectWithValue }) => {
      try {
          const response = await api.post(endpoint, data);
          
          if (response.status !== 200) throw new Error('Failed to create content');
          return response.data; 
      } catch (error) {
          // console.error(error);

          if(error.response && error.response.data && error.response.data.error){
            return rejectWithValue(error.response.data.error);    
          }

          return rejectWithValue(error.message);
      }
  }
);

const noticeSlice = createSlice({
  name: "notice",
  initialState: {
    categories: [],
    contentList: [],
    alarmContentList:[],
    totalCount: 0,
    totalLatestCount : 0,
    content: {},
    loading: false,
    error: null,
    createContentStatus: {
      success: false,
      error: null,
    },
    updateContentStatus: {
      success: false,
      error: null,
    },
    deleteContentStatus: {
      success: false,
      error: null,
    },
  },
  
  reducers: {
    resetDeleteContentStatus(state) {
      state.deleteContentStatus.success = null;
    },
    setEndpoint(state, action) {
      state.endpoint = action.payload; 
    },
    clearEndpoint: (state) => {
      state.endpoint = '';  
    },
  },
  
  extraReducers: (builder) => {
    builder
      .addCase(getCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(getCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createContent.pending, (state) => {
        state.loading = true;
        state.createContentStatus.success = false;
        state.createContentStatus.error = null;
      })
      .addCase(createContent.fulfilled, (state, action) => {
        state.loading = false;
        state.createContentStatus.success = true;
        state.categories.push(action.payload);
      })
      .addCase(createContent.rejected, (state, action) => {
        state.loading = false;
        state.createContentStatus.success = false;
        state.createContentStatus.error = action.payload;
      })
      .addCase(getContentList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContentList.fulfilled, (state, action) => {
        state.loading = false;
        state.contentList = action.payload.contentList;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getContentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAlarmContentList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAlarmContentList.fulfilled, (state, action) => {
        state.loading = false;
        state.alarmContentList = action.payload.alarmContentList;
        state.totalLatestCount = action.payload.totalLatestCount; 
      })
      .addCase(getAlarmContentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getContent.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContent.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload.content;
        state.files = action.payload.files;
        state.preview = action.payload.content.PREVIEW_YN;
        state.prev = action.payload.prev; 
        state.next = action.payload.next; 
      })
      .addCase(getContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteContent.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteContent.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteContentStatus.success = true;
        state.deleteContentStatus.error = null;
      })
      .addCase(deleteContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.deleteContentStatus.error = action.payload;
      })
      .addCase(updateContent.pending, (state) => {
        state.loading = true;
        state.updateContentStatus.success = false;
        state.updateContentStatus.error = null;
      })
      .addCase(updateContent.fulfilled, (state, action) => {
        state.loading = false;
        state.updateContentStatus.success = true;

        const updatedContentIndex = state.contentList.findIndex(item => item.id === action.payload.id);
        if (updatedContentIndex !== -1) {
          state.contentList[updatedContentIndex] = action.payload;
        }
      })
      .addCase(updateContent.rejected, (state, action) => {
        state.loading = false;
        state.updateContentStatus.success = false;
        state.updateContentStatus.error = action.payload;
      });
}});

export const { resetDeleteContentStatus, setEndpoint, clearEndpoint } = noticeSlice.actions;
export default noticeSlice.reducer;
